/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import User from '../User'
import NewUser from '../NewUser'
import EditUser from '../EditUser'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/users',
    name: 'user',
    component: User,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users/create',
    name: 'new-user',
    component: NewUser,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/users/edit/:id',
    name: 'edit-user',
    component: EditUser,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/user/routes/index.js